<div #modal class="modal fade"  tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog "
       [ngClass]="{
       'modal-dialog-scrollable' : scrollable,
       'modal-xl': isExtraLarge(),
       'nodal-lg' : isLarge(),
       'modal-sm' : isSmall()
       }"> <!-- modal-dialog-scrollable modal-xl -->
    <ng-content></ng-content>
  </div>
</div>
